import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    Grid,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
    FormControl, InputLabel, Input, FormHelperText, Typography
} from "@deere/fuel-react";
import {Controller, useForm} from "react-hook-form";
import {
    EDIT_OVERRIDE,
    OVERALL_SCORE_OVERRIDE,
    OVERRIDE,
} from "../Constants";
import EditIcon from "@material-ui/icons/Edit";
import {FormSelect} from "../FormSelect";
import {ModalDialog} from "../ModalDialog";

export const RatingsOverrideModal = ({reasons, isEdit = false, totalOverrideObj, onSave}) => {
    const [open, setOpen] = useState(false);
    const [reasonsList, setReasonsList] = useState([]);
    const [reasonValue, setReasonValue] = useState("");
    const [comment, setComment] = useState("");
    const [score, setScore] = useState("");
    const [error, setError] = useState("");
    const [characterCount, setCharacterCount] = useState(0);
    const {control} = useForm();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        !isEdit && resetState();
    };

    const validateFormValues = () => {
        const isAnyEmpty = score === "" || reasonValue === "" || comment === ""
        return !isAnyEmpty
    }

    const onSubmit = () => {
        const isValid = validateFormValues()
        if (!isValid)
            setError("Please fill all details")
        else {
            onSave({
                score: score,
                reason: reasonValue,
                comment: comment
            },"save")
            handleClose()
        }
    }

    const onDelete = () => {
        onSave({
            score: score,
            reason: reasonValue,
            comment: comment
        }, "delete")
        handleClose()
    }

    const handleReasonChange = (event) => {
        setReasonValue(event.target.value);
    };

    const resetState = () => {
        setScore("");
        setReasonValue("");
        setComment("");
        setCharacterCount(0)
        setError("")
    }

    useEffect(() => {
        const filteredData = reasons.filter(item => item.type === "total_override")
        setReasonsList(filteredData);

        return () => {
            setReasonsList([]);
            resetState();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reasons]);

    useEffect(() => {

        setScore(totalOverrideObj ? totalOverrideObj.overridePoints : "")
        setComment(totalOverrideObj ? totalOverrideObj.comments : "")
        setCharacterCount(totalOverrideObj ? totalOverrideObj.comments.length : 0)
        setReasonValue(totalOverrideObj ? totalOverrideObj.reasonId : "")

        return () => {
            setScore("")
            setComment("")
            setReasonValue("")
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalOverrideObj]);

    return (
        <Box display="inline">
            <Button variant="text" onClick={handleClickOpen} style={{marginTop: "-.5rem"}}><EditIcon
                style={{paddingRight: ".25rem"}}/>{isEdit ? EDIT_OVERRIDE : OVERRIDE}</Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
                maxWidth="md"
                fullWidth={true}
            >
                <ModalTitle onClose={handleClose} id="alert-Modal-title">
                    {OVERALL_SCORE_OVERRIDE}
                </ModalTitle>
                <ModalContent>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Box p={2}>
                                <FormSelect
                                    label={"Override Reason"}
                                    defValue={reasonValue}
                                    name={"Override Reason"}
                                    options={reasonsList}
                                    onTypeChange={handleReasonChange}
                                    isShowSelect={true}
                                    required={true}
                                    control={control}
                                    type={"overrideScore"}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box p={2}>
                                <FormControl>
                                    <InputLabel htmlFor="score">Points Adjustment
                                        <span style={{
                                            marginLeft: ".25rem",
                                            display: "inline"
                                        }}
                                              aria-label="required field"
                                              className="uxf-is-required"
                                        > * </span>
                                    </InputLabel>
                                    <Controller
                                        rules={{required: true}}
                                        control={control}
                                        defaultValue={score}
                                        value={score}
                                        name={"score"}
                                        render={({onChange, value}) => (
                                            <Input
                                                style={{maxWidth: "100px"}}
                                                id="score"
                                                placeholder="Points"
                                                value={value}
                                                onChange={(e) => {
                                                    onChange(e.target.value)
                                                    setScore(e.target.value)
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box p={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="reasonComment">Comments
                                        <span style={{
                                            marginLeft: ".25rem",
                                            display: "inline"
                                        }}
                                              aria-label="required field"
                                              className="uxf-is-required"
                                        > * </span>
                                    </InputLabel>
                                    <Controller
                                        rules={{required: true}}
                                        control={control}
                                        defaultValue={comment}
                                        value={comment}
                                        name={"reasonCommentOverride"}
                                        render={({onChange, value}) => (
                                            <Input
                                                onChange={(e) => {
                                                    setCharacterCount(e.target.value.length)
                                                    setComment(e.target.value)
                                                    onChange(e.target.value)
                                                }}
                                                value={value}
                                                label={"Text Value"}
                                                multiline={true}
                                                aria-multiline={true}
                                                placeholder="Start Typing Comment..."
                                                minRows={3}
                                                rowsMin={3}
                                                style={{padding: 0}}
                                                inputProps={
                                                    {maxLength: 250}
                                                }/>
                                        )}
                                    />
                                    <Box display="flex" justifyContent="flex-end">
                                        <Typography variant="caption" color="secondary" component="p">
                                            {characterCount} / 250
                                        </Typography>
                                    </Box>
                                </FormControl>
                            </Box>
                        </Grid>
                    </Grid>
                </ModalContent>
                <ModalActions>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end">
                                <FormHelperText error={error !== ""} style={{padding: ".5rem"}}>{error}</FormHelperText>
                                {isEdit &&
                                <ModalDialog
                                    titleText={"Delete Override"}
                                    content={<React.Fragment> Are you sure you want to delete the
                                        override?</React.Fragment>}
                                    saveButtonText={"Delete"}
                                    onSave={onDelete}
                                    page={"Ratings"}
                                />
                                }
                                <Button variant="secondary" style={{marginRight: ".5rem"}} size="medium"
                                        onClick={handleClose}>Cancel</Button>
                                <Button variant="primary" size="medium" type="submit"
                                        onClick={() => onSubmit()}
                                >Save</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </ModalActions>
            </Modal>
        </Box>
    );
};
